import React from 'react';
import { Button, Col, ControlLabel, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import FieldGroup from '../../FieldGroup.jsx';
import { getOrgTermsContent } from '../../../content/utils.js';
import EmployeesFormField from '../../employees-form-field/EmployeesFormField.jsx';
import GroupsBulkSelect from '../../GroupsBulkSelect.jsx';

function EmployeeForm({
  onManualSubmit,
  onManualCancel,
  values,
  isInitiative,
  disabledGroupIds,
  onGroupSelect,
  selectedEntities,
  onParentSelect,
  isGroupSelectDisabled,
  manuallyGeneratedError = {},
}) {
  return (
    <React.Fragment>
      <Row>
        {isInitiative ? (
          <Col xs={12}>
            <div className="text-muted m-b-32">
              Employee will appear in Organization and current{' '}
              {getOrgTermsContent('initiative')}
            </div>
          </Col>
        ) : null}
        <Col xs={12}>
          <Field
            id="firstName"
            name="firstName"
            label="First Name"
            placeholder="Enter here"
            type="text"
          >
            {(props) => (
              <FieldGroup
                {...props}
                manuallyGeneratedError={manuallyGeneratedError.firstName}
              />
            )}
          </Field>
        </Col>
        <Col xs={12}>
          <Field
            id="lastName"
            name="lastName"
            label="Last Name"
            placeholder="Enter here"
            type="text"
          >
            {(props) => (
              <FieldGroup
                {...props}
                manuallyGeneratedError={manuallyGeneratedError.lastName}
              />
            )}
          </Field>
        </Col>

        <Col xs={12}>
          <Field
            id="email"
            name="email"
            label="Email"
            placeholder="Enter here"
            type="email"
          >
            {(props) => (
              <FieldGroup
                {...props}
                manuallyGeneratedError={manuallyGeneratedError.email}
              />
            )}
          </Field>
        </Col>
        <Col xs={12}>
          <Field
            id="position"
            name="position"
            label="Position"
            placeholder="Enter here"
            type="text"
            component={FieldGroup}
          />
        </Col>
        <Col xs={12}>
          <Field
            id="location"
            name="location"
            label="Location"
            placeholder="Enter here"
            type="text"
            component={FieldGroup}
          />
        </Col>
        <Col xs={12}>
          <Field
            id="externalId"
            name="externalId"
            label="Employee ID"
            placeholder="Enter here"
            type="text"
            component={FieldGroup}
          />
        </Col>
        <Col xs={12}>
          <ControlLabel>Group</ControlLabel>
          <GroupsBulkSelect
            selected={selectedEntities.group}
            handleSelect={onGroupSelect}
            isGroupSelectDisabled={isGroupSelectDisabled}
            disabledGroupIds={disabledGroupIds}
            isItemActive={(id) =>
              selectedEntities.group.some((g) => g.id === id)
            }
          />
        </Col>
        <Col xs={12} className="m-b-24">
          <EmployeesFormField
            selected={selectedEntities.parent}
            handleSelect={onParentSelect}
            additionalSearchParams={{}}
            title="Supervisor"
            multiple={false}
            isItemActive={(id) =>
              selectedEntities.parent.some((e) => e.id === id)
            }
          />
        </Col>
      </Row>
      {onManualSubmit ? (
        <Row>
          <Col sm={6}>
            <Button type="button" block onClick={onManualCancel}>
              Cancel
            </Button>
          </Col>
          <Col sm={6}>
            <Button
              block
              bsStyle="primary"
              onClick={() => onManualSubmit(values)}
            >
              Save
            </Button>
          </Col>
        </Row>
      ) : null}
    </React.Fragment>
  );
}

export default EmployeeForm;
